import React, { useState, useEffect } from "react";
import Card from "../../../components/card/Card";
import DocumentsModulesEdit from "../admin/DocumentsModulesEdit";

import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import {
  GetDocumentModule,
  selectDocumentModule,
} from "../../../features/learning/DocumentSlice";
import { useParams } from "react-router-dom";
const title: String = "Documents";

const Document = () => {
  const dispatch = useAppDispatch();
  const params = useParams();

  const { categoryId }: any = params || "";
  const DocumentModule = useAppSelector(selectDocumentModule);
  const userDetails = localStorage.getItem("userDetails");
  const userDetailsList: any = userDetails;
  const userDetailsJson = JSON.parse(userDetailsList);

  useEffect(() => {
    var data = {
      keyword: "",
      offset: 0,
      companyId: userDetailsJson.companyId,
      categoryId,
    };
    // async function fetchLearningModuleData() {
    //   let sample = await dispatch(GetDocumentModule(data));
    // }
    // fetchLearningModuleData();
    dispatch(GetDocumentModule(data));
  }, [dispatch]);

  const rowLearnArrayData = DocumentModule?.slice(0, 4);
  const Docslist: any = rowLearnArrayData;
  //alert(Docslist)
  const fetchLearningModuleData = () => {
    var data = {
      keyword: "",
      offset: 0,
      categoryId,
    };
    dispatch(GetDocumentModule(data));
  };
  return (
    <>
      <Card
        type={1}
        title={title}
        data={Docslist}
        fetchLearningModuleData={fetchLearningModuleData}
        modal={
          <>
            <DocumentsModulesEdit data={DocumentModule} />
          </>
        }
        // modal= {<HelpDocumentsModulesEdit data={DocumentModule} />}
        modalLink="VIEW"
      />
    </>
  );
};

export default Document;
